import React from 'react';
import { useTranslation } from 'next-i18next';
import FilterDropdown, { DARK_THEME, FilterDropdownTheme } from 'components/search-bar/advanced-search/filter-dropdown';
import ButtonGroup from 'components/control/button-group';
import { searchFilterIds } from 'constants/test-constants';
import TagIcon from 'components/icon/filters/tag-icon';
import { LOCALE_SEARCH_PATHS, Namespaces } from 'types/locales';

//#region Types
export interface BuyOrRentFilterDropdownProps {
  rental: boolean;
  theme?: FilterDropdownTheme;
  onValueChange(value: boolean): void;
}
//#endregion

const BuyOrRentFilterDropdown = ({ rental, onValueChange, theme = DARK_THEME }: BuyOrRentFilterDropdownProps) => {
  const { t } = useTranslation(Namespaces.SEARCH);

  // Create translated options for the ButtonGroup
  const translatedOptions = [
    { 
      value: false, 
      label: t(LOCALE_SEARCH_PATHS.FILTER_LABELS_BUY_LISTINGS, { 
        defaultValue: 'Buy Listings', 
      }), 
    },
    { 
      value: true, 
      label: t(LOCALE_SEARCH_PATHS.FILTER_LABELS_RENT_LISTINGS, { 
        defaultValue: 'Rent Listings', 
      }), 
    },
  ];

  // Get translated label for the dropdown
  const dropdownLabel = rental 
    ? t(LOCALE_SEARCH_PATHS.FILTER_LABELS_RENT, { defaultValue: 'Rent' })
    : t(LOCALE_SEARCH_PATHS.FILTER_LABELS_BUY, { defaultValue: 'Buy' });

  return (
    <FilterDropdown
      theme={theme}
      label={dropdownLabel}
      testId={searchFilterIds.buyOrRentDropdownMap}
      icon={<TagIcon />}
      isDefaultValue={!rental}
    >
      <ButtonGroup
        options={translatedOptions}
        value={rental || false}
        onValueChange={onValueChange}
        size='large'
      />
    </FilterDropdown>
  );
};

export default BuyOrRentFilterDropdown;
